<template>
  <el-container class="teachingPlan" style="display: flex">
    <el-aside class="teachingPlan-left">
      <div class="title">教学计划树</div>
      <div class="teachingPlan-search">
        <el-tree
          :data="ClassInfoTree"
          :props="ChapterProps"
          :expand-on-click-node="false"
          class="teachingPlan-tree"
          ref="tree"
          node-key="id"
        >
          <span
            class="span-ellipsis"
            slot-scope="{ node, data }"
            @click="handleNodeClick(data)"
            @mousemove="mousemoveShow = data"
            @mouseleave="mousemoveShow = ''"
          >
            <span :title="data.name">
              <div v-if="node.level == 4"></div>
              <div class="tree-width">{{ data.name }}</div>
              <span v-if="mousemoveShow == data">
                <i
                  v-auth="'teachingPlan_/plan/deletePlan'"
                  v-if="node.level == 4 && (admin == 1 || data.systemDefault == -1)"
                  class="left-top-bottom el-icon-delete"
                  @click="(clickTrue = false), deletePlan(data)"
                ></i>
                <i
                  v-auth="'teachingPlan_/plan/updatePlan'"
                  v-if="node.level == 4 && (admin == 1 || data.systemDefault == -1)"
                  class="left-top-bottom el-icon-edit"
                  @click="(clickTrue = false), editPlan(data)"
                ></i>
                <i
                  v-auth="'teachingPlan_addTeachingPlan'"
                  v-if="node.level == 1"
                  class="el-icon-plus left-top-bottom"
                  @click="(clickTrue = false), addTeachingPlan()"
                ></i>
              </span>
            </span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="teachingPlan-right">
      <el-card>
        <div class="teachingPlan-header">
          <el-cascader
            v-auth="'teachingPlan_/plan/pageList'"
            clearable
            v-model="courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
          <!-- <div class="classRoomButton" @click="addTeachingPlan">添加教学计划</div> -->
          <el-button
            type="primary"
            class="classRoomButton"
            icon="el-icon-plus"
            @click="addTeachingPlan"
            v-auth="'teachingPlan_addTeachingPlan'"
            >添加教学计划</el-button
          >
        </div>
        <el-table
          v-auth="'teachingPlan_/plan/pageList'"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          ref="multipleTable"
          :data="planList.records"
          style="width: 100%; margin-top: 0px"
          row-key="id"
          border
        >
          <el-table-column
            prop="subjectCourseName"
            label="科目"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="name"
            label="教学计划"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <div
                v-if="admin == 1 || scope.row.systemDefault == -1"
                class="operationGroup"
              >
                <span
                  class="icon-style el-icon-edit"
                  @click="editPlan(scope.row)"
                  v-auth="'teachingPlan_/plan/updatePlan'"
                ></span>
                <span
                  v-auth="'teachingPlan_/plan/deletePlan'"
                  class="icon-style el-icon-delete"
                  @click="deletePlan(scope.row)"
                ></span>
              </div>
              <span v-else>暂无权限</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-auth="'teachingPlan_/plan/pageList'"
          background
          layout="prev, pager, next, jumper,  total, sizes"
          style="margin-top: 20px; text-align: left"
          :total="planList.total"
          :page-size="planList.pageSize"
          :page-sizes="[10, 20, 30, 40]"
          :current-page="planList.pageNumber"
          @size-change="classRoomSizeChange"
          @current-change="classRoomCurrentChange"
        ></el-pagination>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      admin: JSON.parse(localStorage.getItem("user")).admin,
      mousemoveShow: "",
      loading: true,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeList: [],
      planSearch: {
        pageNumber: 1,
        pageSize: 10,
      },
      courseIds: [],
      planList: {},
      ClassInfoTree: [],
      ChapterProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      clickTrue: true,
    };
  },
  computed: {},
  methods: {
    addTeachingPlan() {
      this.$router.push({ path: "/addTeachingPlan" });
    },
    getTree() {
      this.api.subjectCourse
        .getPlanTree()
        .then((result) => {
          this.ClassInfoTree = result.data;
          if (this.ClassInfoTree.length === 0) {
            this.$message.error("暂无教学计划，请添加教学计划");
            this.loading = false;
          } else {
            this.planSearch.subjectCourseId = this.ClassInfoTree[0].id;
            this.pageList();
            this.$nextTick(function () {
              this.$refs.tree.setCurrentKey(this.planSearch.subjectCourseId);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeListByAgentId()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                }
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.api.plan.pageList(this.planSearch).then((result) => {
        if (result.success) {
          this.planList = result.data;
          this.loading = false;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    handleNodeClick(data) {
      if (this.clickTrue == true) {
        this.planSearch.subjectCourseId = data.id;
        this.pageList();
      } else {
      }
    },
    deletePlan(item) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        let obj = { id: item.id };
        this.api.plan.deletePlan([obj]).then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            const totalPage = Math.ceil(
              (this.planList.total - 1) / this.planList.pageSize
            );
            const pagenum =
              this.planList.pageNumber > totalPage ? totalPage : this.planList.pageNumber;
            this.planList.pageNumber = pagenum < 1 ? 1 : pagenum;
            this.pageList();
            this.getTree();
            this.clickTrue = true;
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    editPlan(item) {
      this.$router.push({ path: "/addTeachingPlan", query: { id: item.id } });
    },
    subjectSearchChange() {
      this.planSearch.pageNumber = 1;
      this.planSearch.subjectCourseId = this.courseIds[2];
      this.pageList();
    },
    classRoomSizeChange(pageSize) {
      this.planSearch.pageSize = pageSize;
      this.pageList();
    },
    classRoomCurrentChange(pageNumber) {
      this.planSearch.pageNumber = pageNumber;
      this.pageList();
    },
  },
  watch: {},
  mounted() {
    this.getTree();
    this.getSubjectTreeList();
  },
};
</script>
<style scoped>
.teachingPlan {
}
.teachingPlan-left {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
  /* border-right: 1px solid rgba(238, 238, 238, 1); */
}
.teachingPlan-right {
  /* padding: 20px; */
  padding: 0px 20px !important;
}
.teachingPlan-search {
  padding: 0px 10px;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.tree-class {
  background-color: rgba(36, 210, 181, 1);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}
.teachingPlan-header {
  margin-bottom: 20px;
}
.classRoomButton {
  /* height: 32px;
  width: 100px;
  color: #fff;
  background-color: #4d94ff;
  text-align: center;
  line-height: 32px; */
  font-size: 14px;
  float: right;
  cursor: pointer;
}
.plan-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
}
.teachingPlan-tree {
  margin-top: 10px;
}
.tree-width {
  max-width: 100px;
  float: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/teachingPlan/index.vue